require('./closest');


//////////////////
// WEBPACK FOOTER
// ./src/sharebase-app/polyfills/index.js
// module id = 1323
// module chunks = 0